import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { formGroup } from "../../common/components/formGroup";
import { ImpiantoLight } from "../../generated";
import ImpiantiClienteStore from "../ImpiantiClienteStore"
import { Loading } from "../../common/components/loading"
import DatesHelper from "../../common/datesHelper";

const DropdownList = Dropdown<ImpiantoLight>();
interface Props {
    idCliente: number | undefined;
    value: ImpiantoLight | number | null,
    onChange: (type: ImpiantoLight | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
    allowNull?: boolean;
    readOnly?: boolean;
}

const ItemComponent = ({ item, isDetailedView }: { item: ImpiantoLight, isDetailedView: boolean }) => <div className="d-flex flex-column">
    <div>
        <>
            {item.marca} <strong>{item.modello}</strong> ({item.dataInstallazione
                ? DatesHelper.getReadableDateString(item.dataInstallazione)
                : "N.D."})
        </>
    </div>
    {isDetailedView && item.matricola && <div>
        <small>Mat. <strong>{item.matricola}</strong></small>
    </div>}
</div >

const __ImpiantoSelector = ({ idCliente, allowNull, onChange, value, error, label, onBlur, onFocus, readOnly }: Props) => {
    const data = idCliente ? ImpiantiClienteStore.useForCustomer(idCliente) : [];
    if (!data)
        return <Loading />
    return <DropdownList
        label={label ?? "Impianto"}
        allowNull={allowNull}
        data={data}
        itemComponent={ItemComponent}
        onSelect={onChange}
        value={typeof value == "number" ? data.find(x => x.id == value) ?? null : value}
        error={error}
        textField={item => item.matricola ?? ""}
        onBlur={onBlur}
        onFocus={onFocus}
        readonly={readOnly || data.length == 0}
    />;
}
export const ImpiantoSelector = formGroup(__ImpiantoSelector)

